import {
  Box,
  Stack, Typography
} from '@mui/material'
import classes from "./index.module.css";
import mobileClasses from "./mobile.module.css";
import RpIcon from "@/components/RpIcon";
import useMobileDetect from "next-device-detection";
import PageTitle from "@/constant/PageTitle";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from 'react-router-dom';
import RouteConstant from '@/constant/RouteConstant';

const PageBack = ({onClick, showTitle}) => {
  const detectMobile = useMobileDetect();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const _onBack = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (location.key !== "default") {
      navigate(-1);
    } else {
      navigate(RouteConstant.MAIN);
    }
  }

  return (
    <Stack direction="row" gap={'12px'} alignItems="center"
           className={detectMobile.isMobile ? mobileClasses.root : classes.root}>
      <Box onClick={_onBack} >
        <RpIcon icon="arrow-left" size={24}/>
      </Box>
      {showTitle && <Typography
        sx={theme => ({
          flex: 1,
          textAlign: "center",
          fontFamily: 'Urbanist-bold',
          fontSize: detectMobile.isMobile ? theme.typography.pxToRem(24) : theme.typography.pxToRem(20),
        })}
        className={detectMobile.isMobile ? mobileClasses.pageTitleText : classes.pageTitleText}>{
        t(PageTitle[location.pathname] || 'cards')
      }</Typography>}
    </Stack>
  );
}

export default PageBack